import { BrowserClientSideState } from 'shared/services/ClientSideState';
import { BrowserServerSideState } from 'shared/services/ServerSideState';
import { IApplicationContext } from 'shared/types/ApplicationContext';

import { renderApplication } from '../renderApplication';

export function runApp(context: IApplicationContext): void {
  const browserServerSideState = new BrowserServerSideState(context);
  const browserClientSideState = new BrowserClientSideState(context);

  renderApplication({
    clientSideState: browserClientSideState,
    context,
    serverSideState: browserServerSideState,
  });
}
